<template>
    <section v-if="hasPermissions(['Options-Bed-Codes Read', 'Options-Bed-Codes Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Pariatur dolorem cumque possimus nobis ut iure architecto, assumenda iste cupiditate libero sed debitis magni deleniti enim corporis veniam et aut. Et.
            </p>
        </div>

        <div class="row bar__container">
            <div class="col-md-6 py-0 mb-3 mb-md-0">
                <div class="input-field my-0" v-if="codes.length && hasPermissions(['Options-Bed-Codes Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div v-if="hasPermissions(['Options-Bed-Codes Write'])" class="col-auto flex-grow-1 py-0 d-flex justify-content-between align-items-center duties">
                <button class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="codes.length && hasPermissions(['Options-Bed-Codes Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="codes"
                                :search="search"
                                :checkable="true"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                                :link="'/census-time-tracking/'"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>


        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
          @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Bed Code'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Bed Code Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
// import FormResources    from    './form_resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DinamicTable         from    '@/components/DinamicTable'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {

  name: "BedVacant",

  components: {
    Breadcrumb,
    WaitingModal,
    DeletionModal,
    FormModal,
    UpdateModal,
    DeletionMassiveModal,
    DinamicTable,
    UnauthorizedComponent
  },

  data() {
    return {
      notyf,
      axios,
      user:                 this.get_user(),
      child_href:           '/options-bed-codes/',
      title_page:           'Bed Codes',
      content_header:       this.$store.state.headers,
      rest_api:             `bed_codes`,
      notifications:        this.$store.state.form_notyf,
      table_headers:        Resources.table_headers,
      breadcrumb:           Resources.breadcrumb,
      add_btn:              'Add Bed Code',
      single_select:        false,
      table_selection:      [],
      search:               '',
      global_index:         '',
      single_object:        {},
      codes:                [],
      array_options:        {},
      select_ids:           [],
    }
  },

  methods: {

        format_boolean(value)
        {
            let boolean_string = ''
            value ? boolean_string = 'Show' : boolean_string = 'Hide'
            return boolean_string
        },

        unshift_object(new_object)
        {
            this.codes.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.codes.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility)
            {
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.codes[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.codes[index]
            
            window.$('#static-update').modal('show')
        },
        fill_data(data)
        {
            this.codes = data.bed_codes
        },

        trashing(index){
            this.codes.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.codes.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                id: this.select_ids,
                massive:    true,
            }

            let sendingMassive = await this.massive_deletion(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                const index = this.codes.findIndex(value => value.id == item)
                if(index > -1)
                {
                    this.codes.splice(index, 1)
                }
                })
                this.select_ids = []
            }
        },
  },

  async mounted() {
    if(this.hasPermissions(['Options-Bed-Codes Read']))
    {
        await this.api_request()
    }
  },

    computed:
    {
        selected()
        {
            const bool = this.codes.filter(item => item.checked)
            return Boolean(bool.length)
        }
    },
};
</script>